<template>
    <div class="order-record">
        <navigation-bar Back/>
        <div class="main pb-4">

            <div class="no-data" v-if="recordList.length===0">
                <img src="@/assets/images/empty.svg">
                <p>OH！目前空空的</p>
            </div>

            <div v-for="(item,index) in recordList" :key="index" class="list-style2">
                <el-image :src="item.storeInfo.brandImage" fit="cover" class="pic" lazy>
                    <div slot="error" class="image-slot"/>
                </el-image>
                <div class="content">
                    <div class="d-flex">
                        <h3 class="flex-grow-1">{{item.storeInfo.brandName}}-{{item.storeInfo.storeName}}</h3>
                        <div class="right">
                            <p class="type dark" v-if="item.takeoutStatus === 0">訂單成立</p>
                            <p class="type blue" v-else-if="item.takeoutStatus === 1">出餐中</p>
                            <p class="type yellow" v-else-if="item.takeoutStatus === 2">配送中</p>
                            <p class="type yellow" v-else-if="item.takeoutStatus === 3">待取餐</p>
                            <p class="type dark" v-else-if="item.takeoutStatus === 5">已完成</p>
                            <p class="type dark" v-else-if="item.takeoutStatus === 4 && item.paymentStatus === 2">已退款</p>
                            <p class="type red" v-else-if="item.takeoutStatus === 4 && item.paymentStatus !== 2">已取消</p>
                        </div>
                    </div>
                    <p class="add">{{item.storeInfo.city+item.storeInfo.township+item.storeInfo.address}}</p>
                    <p class="time mt-2">{{item.estimatedTimeString}}</p>
                    <p class="time mt-2 red"><span class="red">{{item.timeString}}</span></p>
                </div>

                <div class="top-cart-list">
                    <div class="input-group mt-2">
                        <div class="name">
                            {{item.mealAmount}}份餐點
                        </div>
                        <div class="fee red">
                            $ {{item.invoicePrice}}
                        </div>
                    </div>
                </div>
                <div class="red" v-if="item.takeoutStatus === 4">
                    {{item.isUserCancel ? "會員取消：" : "店家取消："}}{{item.cancelReason}}
                </div>
                <div class="button-list">
                    <!--todo 總共有以下狀態-->
                    <el-button round @click="$router.push({name: 'OrderCart'})" v-if="false">編輯清單</el-button><!--todo 預點時 的狀態-->
                    <el-button round @click="$router.push({name: 'OrderQrCodeScheduled'})" v-if="false">開啟清單</el-button><!--todo 預點時 的狀態-->
                    <el-button round @click="$router.push({name: 'OrderRecordDetail',query:{orderSn:item.orderSn}})">查看明細</el-button>
                    <el-button v-if="false" round class="line-btn"><a href="http://line.me/ti/p/@pkf7762b" target="_blank">
                        <img src="../../assets/images/share-line.svg">聯繫小短腿</a>
                    </el-button>
                </div>
            </div>
            <infinite-loading spinner="waveDots" @infinite="setupData">
              <div slot="no-more">沒有更多資料</div>
              <div slot="no-results"></div>
            </infinite-loading>
            <!--todo 取消訂單彈框-->
            <el-dialog
                    v-if="showModel"
                    :visible.sync="showModel"
                    top="20%"
                    width="80%"
                    custom-class="commDialog">
                <div class="container">
                    <img src="@/assets/images/dialog-order.svg" class="icon">
                    <p class="text-center">餐點取消無法復原<br>若需下訂請重新點餐</p>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="info">取消訂餐</el-button>
                    </div>
                </div>
            </el-dialog>
            <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
            </loading>
        </div>
    </div>

</template>

<script>
    import {notNull} from '@/util/common';

    export default {
        name: "OrderRecordList",
        data() {
            return {
                isLoading: false,
                showModel:false,//刪除餐點
                recordList:[],
                offset: 0,
                pageSize: 10,
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            setupData($state) {
                this.$http.fetchWithAuth`GetOnlineOrderList${{
                    storeId:this.$route.query.storeId!==undefined? Number(this.$route.query.storeId):0,
                    offset: this.offset,
                    pageSize: this.pageSize,
                }}
                ${json => {
                    let self = this
                    if (json.status) {
                      if (notNull(json.data)) {
                          if (json.data.length >= self.pageSize) {
                            self.offset++;
                            self.recordList.tmz_load_push(...json.data);
                            $state.loaded();
                          } else {
                            self.offset++;
                            self.recordList.tmz_load_push(...json.data);
                            $state.complete();
                          }
                        } else {
                          $state.complete();
                        }
                    }
                }}`;
            },
        },
        watch: {
          '$store.state.changePageData.isChangePage': function() {
            if(this.$store.state.changePageData.isChangePage) {
              this.recordList.some(item => {
                if(parseInt(item.takeoutId) === parseInt(this.$store.state.changePageData.takeoutId)) {
                  item.takeoutStatus = parseInt(this.$store.state.changePageData.status)
                  item.cancelReason = this.$store.state.changePageData.cancelReason
                  return true
                }
              })

              this.$store.commit('setChangePageData',{
                isChangePage: false,
              });
            }
          }
        }
    }
</script>
<style lang="less" scoped src="../../less/order.less"/>
